export default class CreatePlaceStrategy {
  constructor(store) {
    this.store = store;
  }

  save(form) {
    return this.store.dispatch('place/updatePassengerPlace', { place: form, type: form.type });
  }
}
